const tableColumns = [
  // {
  //   prop: 'status',
  //   label: 'Status',
  //   sortable: true,
  //   width: 130
  // },
  {
    prop: 'createdOn',
    label: 'Date',
    sortable: true
  },
  {
    prop: 'sensors',
    label: '# of Sensors',
    sortable: true,
    width: 175
  },
  {
    prop: 'released',
    label: '# of Released',
    sortable: true,
    width: 175
  },
  {
    prop: 'pending',
    label: '# of Pending',
    sortable: true,
    width: 175
  }
];

const tableFilters = [
  {
    label: 'pending',
    name: 'pending',
    search: 'status',
    param: 'pending'
  },
  {
    label: 'released',
    name: 'released',
    search: 'status',
    param: 'released'
  },
  {
    label: 'weak',
    name: 'weak',
    search: 'strength',
    param: 'weak'
  },
  {
    label: 'night',
    name: 'night',
    search: 'day',
    param: false
  }
];

const detectionTableOptions = {
  'default-sort': {
    prop: 'date',
    order: 'descending'
  },
  limit: 10
};

export { tableColumns, tableFilters, detectionTableOptions };
